import styled from "styled-components";

export const HeaderStyled = styled.header`
      -webkit-box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.5);
      -moz-box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.5);
      box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.5);
      background-color: var(--primary-color);
      display: block;
  
      & div nav img {
        height: 3em;
      }
  
      position: relative;
      z-index: 99;
    `;